import API from "../plugin/libs/axios";
function addErrorRouter(router) {
  console.log('router======/', router)
  let errorPage = [
    {
      path: '/401',
      name: 'error_401',
      component: () => import(/* webpackChunkName: 'error' */ '../plugin/view/error/401.vue'),
    },
    {
      path: '/500',
      name: 'error_500',
      component: () => import(/* webpackChunkName: 'error' */ '../plugin/view/error/500.vue'),
    },
    {
      path: '*',
      name: 'error_404',
      component: () => import(/* webpackChunkName: 'error' */ '../plugin/view/error/404.vue')
    },
  ]
  router.addRoutes(errorPage)
}
function getLayoutJson(router, resolve, reject) {
  let base = require('js-base64').Base64;
  const port = window.location.port;
  const hostname = window.location.hostname
  const UrlName = '/modular/admin/v1'
  let confUrl = port ? base.encode('qdjm.saas-pc.testing3.wdeduc.com') : base.encode(hostname);
  API({
    url: `${UrlName}/configuration/${confUrl}`,
    method: 'Get',
  })
    .then((data) => {
      if (data.code == "0") {
        localStorage.setItem('setPageConfigs', JSON.stringify(data.data.dragList)) //本地存储数据
        data.data && data.data.dragList && data.data.dragList
          .map((page) => {
            if (!page.uri) { return; }
            const route = {
              path: page.uri.indexOf(':') != -1 ? page.uri.split(':')[0] : page.uri,
              name: page.pageName,
              query: page.uri.indexOf(':') != -1 ? page.uri.split(':')[1] : '',
              component: () => import(/* webpackChunkName: 'common' */ '../plugin/view/common/index.vue'),
              meta: {
                keepAlive: true,
                moduleId: page.pageName,
                name: page.label,
                noLogin: true
              },
            };
            router.addRoute(route);
          });
        resolve(router);

      } else {
        reject(data.message);

      }
    })
    .catch((error) => {
      console.log("error---", error);
    });
}


let setLayoutToRouter = (router) => {
  new Promise((resolve, reject) => {
    getLayoutJson(router, resolve, reject)
  }).then((e) => {
    console.log('e------>', e)
    addErrorRouter(e)
  }).catch((error) => {
    console.log('error--->', error)
  })
}

export default setLayoutToRouter